/**
 * Thin analytics helper — calls window.gtag (Google Analytics 4) if it's
 * available. No-ops silently otherwise, so SSR, misconfigured environments,
 * and ad-blocked clients don't throw.
 *
 * Event schema used by the header redesign (spec §10):
 *   header_cta_click       { variant: 'landing' | 'sticky' | 'mobile' }
 *   header_nav_click       { destination: string }
 *   header_search_submit   { mode: 'reg' | 'text' | 'ai' }
 *   header_category_click  { category: string }
 *   login_open             { trigger: 'header' | 'header_mobile' | ... }
 *
 * Shopping events live in util/ecommerceEvents.js. Both go through gtagSafe,
 * so neither sends anything from a non-production host or before consent.
 */

import { gtagSafe, debugParams } from './tracking';

export const trackEvent = (name, params) => {
  if (!name) return;
  gtagSafe('event', name, { ...(params || {}), ...debugParams() });
};
